/*
 * @Author: lyodon.li lyodon.li@feisu.com
 * @Date: 2025-04-09 15:13:13
 * @LastEditors: lyodon.li lyodon.li@feisu.com
 * @LastEditTime: 2025-05-15 15:01:04
 * @FilePath: /designcenter/src/store/layout.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { defineStore } from 'pinia'
import { getDataCache } from '@/utils'
const cache = getDataCache()

export const useLayoutStore = defineStore('layout', {
  state: () => ({
    isSidebarCollapsed: cache.get('isSidebarCollapsed'),
  }),
  actions: {
    toggleSidebar() {
      this.isSidebarCollapsed = !this.isSidebarCollapsed
      cache.set('isSidebarCollapsed', this.isSidebarCollapsed)
    },
  },
})
